import 'arrive';

// Import Swiper bundle (include tutti i moduli)
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.arrive('.block-recently-published__slider', { existing: true }, function () {
    const recentlyPublishedSwiper = new Swiper('.block-recently-published__slider .swiper', {
        slidesPerView: 1.2,
        spaceBetween: 8,
        centeredSlides: false,
        loop: true,
        breakpoints: {
            767: {
                slidesPerView: 1.2,
                spaceBetween: 8,
            }
        }
    });
});
